export const emails = {
    
    PNT_MAIL:'pnt-india@bluealtair.com',
  
  };

 